import type { ModelLifecycleState } from '@/services/resource.service'

// Maps the wire lifecycle (governance-service sends unknown, available, deprecated,
// missing, replaced or retired) onto the states the UI labels.
export function normalizeLifecycleState(value: unknown): ModelLifecycleState {
  switch (value) {
    case 'deprecated':
    case 'retired':
    case 'needs_migration':
      return value
    default:
      return 'active'
  }
}
